import { DeleteRounded, DragIndicator } from "@mui/icons-material";
import {
	Box,
	Button,
	Dialog,
	DialogActions,
	ListItem,
	ListItemIcon,
	ListItemText,
	MenuItem,
	Select,
	Stack,
	Typography,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import { GlobalState } from "context/GlobalContext";
import { converAttrToDatagridCol, inputTypes, arrType } from "data/globalData";
import { useEffect, useState } from "react";
import { Reorder } from "framer-motion";
import { StudioDashboardState } from "context/StudioDashboardContext";
import { PimDashboardState } from "context/PimDashboardContext";

const colStyle = {
	headerAlign: "center",
	align: "center",
};

const AddColumnModal = ({
	modal,
	handleCloseModal,
	attrColumns,
	setAttrColumns,
	localStorageStr,
	allColumns,
	allColumnsObj,
	defaultColumns,
}) => {
	const { snackBar, setSnackBar, setSnackBarOpen } = GlobalState();
	const { setLoadingOpen } = GlobalState();
	const [extraColState, setExtraColState] = useState(attrColumns?.length ? attrColumns : []);
	const [attrToAdd, setAttrToAdd] = useState(inputTypes.SELECT.key);
	const [attrNameArr, setAttrNameArr] = useState();
	const [updatedAttrNameArr, setUpdatedAttrNameArr] = useState();

	useEffect(() => {
		setExtraColState(attrColumns?.length ? attrColumns : []);
		if (!setAttrNameArr?.length && localStorage.getItem(localStorageStr)) {
			setAttrNameArr(localStorage.getItem(localStorageStr));
			setUpdatedAttrNameArr(localStorage.getItem(localStorageStr));
		} else {
			setAttrNameArr(attrColumns?.map((row) => row?.field));
			setUpdatedAttrNameArr(attrColumns?.map((row) => row?.field));
		}
	}, [attrColumns]);

	// attr ordering

	const handleAttributeReoredr = (valArr) => {
		setUpdatedAttrNameArr(valArr);
	};

	const handleClose = () => {
		handleCloseModal();
		setUpdatedAttrNameArr(attrNameArr);
		setExtraColState(attrColumns);
	};

	const handleColumnAddClick = async () => {
		let attr = allColumns.filter((row) => row.key === attrToAdd)?.[0];
		if (!attr) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: `Please select an attribute to add`,
				severity: "warning",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			return;
		}
		console.log(attr, "ghsaddfghj");
		setExtraColState((prev) => {
			if (prev?.length) return [...prev?.filter((row) => row?.field !== attrToAdd), converAttrToDatagridCol(attr)];
			else return [converAttrToDatagridCol(attr)];
		});
		setUpdatedAttrNameArr([...new Set([...updatedAttrNameArr, attrToAdd])]);
		setAttrToAdd(inputTypes.SELECT.key);
	};
	const handleColumnDelete = (col) => {
		setExtraColState((prev) => {
			if (prev?.length) return prev?.filter((row) => row?.field !== col);
		});
		console.log(extraColState, "sdfbsdjkf");

		setUpdatedAttrNameArr(updatedAttrNameArr?.filter((row) => row !== col));
	};
	const handleResetDefaultClick = (row) => {
		setAttrColumns(defaultColumns.map((row) => converAttrToDatagridCol(row)));
		setAttrNameArr(allColumns?.map((row) => row.name));
		localStorage.removeItem(localStorageStr);
		handleClose();
	};
	const handleApplyClick = async (e) => {
		if (!extraColState?.length) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: `No Conditions to apply`,
				severity: "warning",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});

			return;
		}
		setAttrColumns(
			updatedAttrNameArr
				?.map((row) => {
					return { ...allColumnsObj?.[row] };
				})
				.map((row) => converAttrToDatagridCol(row))
		);
		setAttrNameArr(updatedAttrNameArr);
		localStorage.setItem(localStorageStr, JSON.stringify(updatedAttrNameArr));
		handleCloseModal();
	};

	return (
		<Dialog fullWidth maxWidth="xs" open={modal} onClose={handleClose} scroll="body">
			<Box
				width="100%"
				margin="auto"
				p={2}
				pb={0}
				display="flex"
				flexWrap="wrap"
				alignItems="center"
				boxSizing="border-box"
				// justifyContent="space-around"
			>
				<Typography width="100%" variant="h6">
					Manage Columns
				</Typography>

				<Stack width="100%" spacing={2}>
					<Stack width={400}>
						<Box display="flex" columnGap={1} width="100%">
							<Select
								value={attrToAdd}
								onChange={(e) => setAttrToAdd(e.target.value)}
								fullWidth
								MenuProps={{ PaperProps: { sx: { maxHeight: 200 } } }}
								size="small"
								placeholder="">
								<MenuItem value={inputTypes.SELECT.key}>Select Attribute</MenuItem>
								{allColumns?.map((row) => {
									return (
										<MenuItem value={row?.key} key={row?.name}>
											{row?.["name"]}
										</MenuItem>
									);
								})}
							</Select>
							<Box>
								<Button variant="contained" onClick={handleColumnAddClick}>
									Add
								</Button>
							</Box>
						</Box>
					</Stack>
				</Stack>
				{updatedAttrNameArr ? (
					<Box width="100%">
						<Reorder.Group
							values={updatedAttrNameArr}
							axis="y"
							onReorder={handleAttributeReoredr}
							style={{
								border: `1px solid ${grey[200]}`,
								listStyleType: "none",
								width: "100%",
								padding: 0,
								height: "350px",
								overflowY: "scroll",
							}}>
							{updatedAttrNameArr?.map((item) => (
								<Reorder.Item key={item} value={item}>
									<ListItem sx={{ border: `1px solid ${grey[200]}`, background: "white", padding: "3px" }}>
										<ListItemIcon>
											<DragIndicator />
										</ListItemIcon>
										<ListItemText primary={allColumnsObj?.[item]?.name} />
										<ListItemIcon onClick={() => handleColumnDelete(item)}>
											<DeleteRounded />
										</ListItemIcon>
									</ListItem>
								</Reorder.Item>
							))}
						</Reorder.Group>
					</Box>
				) : (
					<></>
				)}
			</Box>
			<DialogActions>
				<Button variant="outlined" onClick={handleClose}>
					Cancel
				</Button>
				<Button variant="outlined" onClick={handleResetDefaultClick}>
					Reset to Default
				</Button>
				<Button autoFocus variant="contained" sx={{ mr: 1 }} onClick={handleApplyClick} disabled={extraColState?.length === 0}>
					Apply Changes
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default AddColumnModal;
